<div class="col-md-12 content-wrapper align-items-center">
    <app-forgot-password-form (submitted)="onForgotPasswordSubmitted($event)" [error]="error"></app-forgot-password-form>
</div>